import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    padding: 8,
    '&:focus': {
      outline: 0,
    },
  },
  weeksWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
    textTransform: 'capitalize',
  },
  week: {
    display: 'flex',
    marginBottom: 7,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  weekDay: {
    fontSize: 13,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
  dayBlock: {
    fontSize: 13,
    fontWeight: 400,
    color: '#939393',
    '&:hover': {
      background: theme.custom.darkBlue,
      color: '#fff',
    },
  },
  today: {
    fontWeight: 700,
    color: '#606060',
  },
  activeBlock: {
    background: theme.custom.darkBlue,
    color: '#fff',
  },
  diffMonth: {
    visibility: 'hidden',
    opacity: 0,
  },
  disabledBlock: {
    opacity: 0.3,
    '&:hover': {
      background: 'transparent',
      color: '#939393',
    },
  },
}));
